import { css } from 'aphrodite';
import React from 'react';
import { styles } from 'src/styles/TabBar';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

export enum CPOption {
    NSF,
    NIH,
    DOE,
    GENERIC
}

interface ITabBarProps {
    tabContainerStyle?: any
    tabs: string[]
    onTabClick: any,
    activeIndex: number,
    showCP: boolean,
    onCPOptionSelected: (option: CPOption) => void
}

class TabBarState {
    public readonly is_curent_pending_open: boolean = false;
}

export class TabBar extends React.Component<ITabBarProps,TabBarState> {
    
    public static defaultProps = {
        activeIndex : 0,
        tabs : [],
        onTabClick: (_index: any)=>{},
        tabContainerStyle : css(styles.tab_container),
        showCP: true,
        onCPOptionSelected: (option: CPOption)=>{}
    }

    constructor(props: ITabBarProps){
        super(props);
        this.state = new TabBarState();
    }

    public render(){

        let CP;
        if(this.props.showCP){
            CP = <React.Fragment>
                <div className={css(styles.button_cp)}>
                    <Dropdown isOpen={this.state.is_curent_pending_open} toggle={this.toggleCurrentAndPending} >
                        <DropdownToggle caret={true}>
                            Current and Pending
                        </DropdownToggle>
                        <DropdownMenu>
                        <DropdownItem>NSF</DropdownItem>
                        <DropdownItem>NIH</DropdownItem>
                        <DropdownItem>DOE</DropdownItem>
                        <DropdownItem onClick={(e: any)=>{this.props.onCPOptionSelected(CPOption.GENERIC)}} >GENERIC</DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </div>
            </React.Fragment>
        }else{
            CP = <React.Fragment>

            </React.Fragment>
        }

        return (
            <div className={this.props.tabContainerStyle} >
                {
                    this.props.tabs.map(this.renderTab)
                }

                {CP}

            </div>
        );
    }

    public renderTab = (entry: string,index: number) => {

        let tabBarStyles;

        if(index === this.props.activeIndex){
            tabBarStyles = [styles.tab_bar]
        }else{
            tabBarStyles = [styles.tab_bar,styles.hidden]
        }

        return (
            <div className={css(styles.tab)} onClick={this.onTabClick(index)} key={index} >
                    <div className={css(styles.tab_content)} >
                        {entry}                    
                    </div>
                    <div className={css(tabBarStyles)}/>
            </div>
        );
    }

    public onTabClick = (index: number) => (event: any) => {
        this.props.onTabClick(index)
    }

    private toggleCurrentAndPending = () => {
        this.setState({...this.state, is_curent_pending_open: !this.state.is_curent_pending_open})
    }

}




// WEBPACK FOOTER //
// ./src/components/TabBar.tsx